export default __webpack_public_path__ + "static/media/b3.3723dcf7.jpg";